Header.$inject = ['userServer', '$state', 'userProfile', 'applicationInfo']
function Header(userServer, $state, userProfile, applicationInfo){
  var vm = this

  vm.profile = null
  vm.logout = logout
  vm.userProfile = userProfile
  vm.applicationInfo = applicationInfo

  function logout(){
    userServer.logout()
      .then(function(){
        $state.go('login')
      })
  }

  userServer.profile()
    .then(function(result){
      vm.profile = result
    })
}

export default Header